import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const otherDetailsApi = createApi({
  reducerPath: "otherDetailsApi",
  baseQuery,
  tagTypes: ["OtherDetails"],
  endpoints: (builder) => ({
    // GET
    getOtherDetailsById: builder.query({
      query: ({id}) => `export/product/otherdetails/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        return data
      },
    providesTags: ["OtherDetails"],
    }),

    // CREATE
    createOtherDetail: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/product/otherdetails/${id}`,
        method: "PUT",
        body: { productOtherdetials:data },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["OtherDetails"],
    }),
  }),
});

export const {
  useLazyGetOtherDetailsByIdQuery,
  useCreateOtherDetailMutation,
} = otherDetailsApi;
